import React from 'react';
import { Link } from 'react-router-dom';

export const SECTION_ID = 'location';

const HeaderRegionLocation = ({ data, name, previousItem, nextItem }) => {
  const { description, header_image, location_image = '', secondary_location_image = '' } = data;
  return (
    <section id={SECTION_ID} className={`header-region header-region--${SECTION_ID}`}>
      {previousItem && (
        <Link to={previousItem.friendly_url} className="header-region__nav-button header-region__nav-button--prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
            <path
              d="M3.51001 11.73L11.5 3.73999L19.49 11.73"
              stroke="#7D5D84"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h4>{previousItem.name}</h4>
        </Link>
      )}

      {nextItem && (
        <Link to={nextItem.friendly_url} className="header-region__nav-button header-region__nav-button--next">
          <h4>{nextItem.name}</h4>

          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
            <path
              d="M3.51001 11.73L11.5 3.73999L19.49 11.73"
              stroke="#7D5D84"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      )}
      <div className="container">
        <div className={`header-region__location-details`}>
          <h1>{name}</h1>
          <h2>{description}</h2>
        </div>
        {location_image !== '' && (
          <figure className="header-region__location-image">
            <img src={location_image} alt={name} />
          </figure>
        )}
      </div>
    </section>
  );
};

export default HeaderRegionLocation;
